/**
 * Registro do service worker gerado pelo vite-plugin-pwa.
 *
 * Fazemos o registro À MÃO (em vez do useRegisterSW do plugin) porque, neste
 * projeto/versão, o hook NÃO registrava o SW no build — o service worker nunca
 * chegava a instalar em produção (0 registros), então cache offline e convite
 * de instalação ficavam a depender de sorte. Registrar aqui garante o SW no
 * load, de forma testável.
 *
 * Estratégia 'autoUpdate' (ver vite.config.ts): o sw.js chama skipWaiting no
 * install. Quando um novo deploy troca o sw.js, o SW novo assume o controle e
 * dispara `controllerchange` — recarregamos a página UMA vez para servir o
 * bundle novo. Isso elimina o problema de visitante recorrente preso no shell
 * antigo em cache (que fazia, por ex., o convite de instalação reaparecer numa
 * versão já corrigida). Não recarrega no primeiro registro (sem controller
 * anterior o evento não dispara), só em atualizações reais.
 */
export function registrarServiceWorker(): void {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  // Em dev o SW é desligado (devOptions.enabled=false) e /sw.js não existe.
  if (import.meta.env.DEV) return;

  window.addEventListener('load', () => {
    let registro: ServiceWorkerRegistration | undefined;
    navigator.serviceWorker
      .register('/sw.js')
      .then((r) => {
        registro = r;
      })
      .catch(() => {
        /* falha de registro nunca pode derrubar o app */
      });

    let recarregando = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (recarregando) return;
      recarregando = true;
      window.location.reload();
    });

    // FORÇA a checagem de atualização toda vez que o app volta ao foco (é quando
    // o usuário reabre o PWA instalado). Sem isso, o app instalado podia demorar
    // a pegar um deploy novo e seguir servindo o bundle velho em cache. Ao achar
    // um SW novo, ele assume (skipWaiting/clientsClaim) e o controllerchange
    // acima recarrega no bundle novo.
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') registro?.update().catch(() => {});
    });
  });
}
